import { assemble, isRequired } from 'simple-object-validation';
import emailValidators from './emailValidators';

const loginFormValidator = assemble({
  ...emailValidators,
  password: isRequired('Password'),
});

export default loginFormValidator;